import { useState } from "react";
import Menu from "./menu";
import Item from "./menu/item";
import Trigger from "./trigger";
import DropCtx from "./context";

function Drop({ children }) {
	const [open, setOpen] = useState(false);
	return <DropCtx.Provider value={{ open, setOpen }}>
		<div style={{ position: 'relative' }}>
			{children}
		</div>
	</DropCtx.Provider>
}

Drop.Trigger = Trigger;
Drop.Menu = Menu;
Drop.Item = Item;

export default Drop;